import { render } from "./BoardDropdown.vue?vue&type=template&id=65e97254&scoped=true"
import script from "./BoardDropdown.vue?vue&type=script&lang=js"
export * from "./BoardDropdown.vue?vue&type=script&lang=js"

import "./BoardDropdown.vue?vue&type=style&index=0&id=65e97254&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e97254"]])

export default __exports__